/**
 * @file 配置信息
 * @author svon.me@gmail.com
 */

import type {ENV_BUILD} from "src/types/system";

export * from "./env";

export const getEnvBuild = function () {
  const data = __ENV_BUILD as ENV_BUILD;
  if (isDevelopment()) {
    return { ...data, version: void 0 };
  }
  return data;
}

const getDomain = function () {
  let domain;
  const hostName = window.location.hostname;
  if (hostName.includes("localhost")) {
    domain = hostName;
  } else if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostName)) {
    domain = hostName;
  } else {
    const list = hostName.split(".");
    domain = list.slice(-2).join(".");
  }
  return domain;
}

const env: any = import.meta.env || {};

// 当前是否为已编译后的环境
export const isBuild = function () {
  return __ENV_COMMAND === "build";
}

// 当前是否会开发环境
export const isDevelopment = function (): boolean {
  return env.MODE === "development";
}

export const isTest = function () {
  return env.MODE === "tester";
}

export const isProduction = function () {
  return env.MODE === "production";
}

export const VITE_DOMAIN: string = getDomain();

// lint 域名地址
export const VITE_LQA = function () {
  const domain = getDomain();
  if (domain.includes("localhost")) {
    return `//${env['VITE_LQA']}`;
  }
  if(domain === window.location.hostname) {
    return window.location.origin;
  }
  return `//${env['VITE_LQA']}.${domain}`;
};
// 漫画域名地址
export const VITE_LQC = function () {
  const domain = getDomain();
  if (domain.includes("localhost")) {
    return `//${env['VITE_LQC']}`;
  }
  if(domain === window.location.hostname) {
    return window.location.origin;
  }
  return  `//${env['VITE_LQC']}.${domain}`;
};
// 用户中心地址
export const VITE_UserCenter: string = 'https://lint.eci.games/user-service/info';

// 退出地址
export const UserLogout = function () {
  return `${VITE_LQA()}/logout`;
};

export const UserLogin = function () {
  return `${VITE_LQA()}/login?referer=${window.location.href}`;
};

// 项目名称
export const AppName = env.VITE_APP_NAME;

export const TOKEN_VALUE = function (): string | undefined {
  if (isDevelopment()) {
    const value = import.meta.env.VITE_TOKEN;
    if (value) {
      return value;
    }
  }
}

// 接口基础路径
export const API_BASE = import.meta.env.VITE_API_BASE;

// office 回调地址
export const OFFICE_BASE = import.meta.env.VITE_API_OFFICE;

